import { TYPESENSE_ROOT_LEVEL_QUERY_PARAMETERS } from '../../../constants/typesense';

export function isSearchQueryParameter(parameter: string): boolean {

  return TYPESENSE_ROOT_LEVEL_QUERY_PARAMETERS.some(typesenseFilter => parameter.includes(typesenseFilter));

}
